const environment = (): string | undefined => {
    const url = window.location.href;
    const urlWithoutHttps = url.replace(/^https?:\/\//, '').split('.');

    const firstUrlSegment = urlWithoutHttps[1];
    const firstUrlSegmentSubpath = urlWithoutHttps[0];
    let env = process.env.VUE_APP_MODE;

    if (firstUrlSegment === 'baloise' && firstUrlSegmentSubpath !== 'www') {
        env = firstUrlSegmentSubpath.split('-')[0];
    } else if (firstUrlSegment === 'apps') {
        env = firstUrlSegmentSubpath.substring(firstUrlSegmentSubpath.lastIndexOf('-') + 1, firstUrlSegmentSubpath.length);
    }
    return env;
};

import { constructionUtil } from '@/app/utils/construction-utils';

const apiPathBuilder = (): string | undefined => {
    const hostname = location.hostname;
    const url = window.location.href;
    return constructionUtil.getBaseUrl(hostname, url);
};

export const appConfig: AppConfig = {
    env: environment() || 'local',
    basePath: process.env.VUE_APP_BASE_ROUTE as string,
    baseUrl: process.env.VUE_APP_BASE_URL as string,
    apiPath: apiPathBuilder(),
    routerDisableRefreshRerouting: process.env.VUE_APP_ROUTER_DISABLE_REFRESH_REROUTING === 'true',
    language: 'de',
};

export const isProduction = () => appConfig.env === 'production' || appConfig.env === 'acc' || appConfig.env === 'prod';

export const isDevelopment = () => !isProduction();

export interface AppConfig {
    env: string;
    basePath: string;
    baseUrl: string;
    apiPath: string | undefined;
    language: string;
    routerDisableRefreshRerouting: boolean;
}
